<template>
  <div>
    <!-- <div class="tabs">
      <ul>
        <li :class="{ 'is-active': tab === 'customer-info'}"><a @click="tab='customer-info'">{{ customerInfoTitle }}</a></li>
      </ul>
    </div> -->

    <customer-info v-if="tab === 'customer-info'" />
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import CustomerInfo from './CustomerViews/CustomerInfo.vue'

export default {
  components: {
    CustomerInfo
  },

  data () {
    return {
      tab: 'customer-info'
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    ...mapGetters('auth', ['hasPermission']),

    customerInfoTitle () {
      return this.user.customerName || 'Företagsinformation'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/Dashboard/DashboardCustomer.vue